var _rect, _text, _rect2, _circle, _text2, _text3, _rect3, _circle2, _text4, _text5, _rect4, _circle3, _text6, _text7, _rect5, _circle4, _text8, _text9, _path, _path2, _path3, _rect6, _text0, _path4, _rect7, _circle5, _text1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentImplementationAdoptionOperationalModelDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 450,
    viewBox: "0 0 720 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Implementation and adoption model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 718,
    height: 448,
    rx: 27,
    fill: "#EEF5FC",
    stroke: "#BED7EE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 42,
    fill: "#087CFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34,
    dy: 0
  }, "IMPLEMENTATION WORKSTREAMS"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 72,
    width: 150,
    height: 68,
    rx: 14,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 106,
    r: 8,
    fill: "#087CFF",
    fillOpacity: 0.18,
    stroke: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 77,
    y: 100,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 820
  }, "PEOPLE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 77,
    y: 119,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 620
  }, "Training and adoption")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 72,
    width: 150,
    height: 68,
    rx: 14,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 106,
    r: 8,
    fill: "#30D6A1",
    fillOpacity: 0.18,
    stroke: "#30D6A1"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 241,
    y: 100,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 820
  }, "DATA")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 241,
    y: 119,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 620
  }, "Migration and quality")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 72,
    width: 150,
    height: 68,
    rx: 14,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 106,
    r: 8,
    fill: "#FF2775",
    fillOpacity: 0.18,
    stroke: "#FF2775"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 415,
    y: 100,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 820
  }, "INTEGRATIONS")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 415,
    y: 119,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 620
  }, "Interfaces and access")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 72,
    width: 150,
    height: 68,
    rx: 14,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 106,
    r: 8,
    fill: "#F4B63D",
    fillOpacity: 0.18,
    stroke: "#F4B63D"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 579,
    y: 100,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 820
  }, "CONTROLS")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 579,
    y: 119,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 620
  }, "Rules and assurance")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109 140v54M273 140v54M447 140v54M611 140v54",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109 194h502",
    stroke: "#4A9BE4",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360 194v28",
    stroke: "#4A9BE4",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 223,
    width: 228,
    height: 90,
    rx: 19,
    fill: "#07152A"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 260,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 16,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 360,
    dy: 0
  }, "ONE IMPLEMENTATION"), /*#__PURE__*/React.createElement("tspan", {
    x: 360,
    dy: 20
  }, "PLAN"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360 313v30",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 344,
    width: 652,
    height: 68,
    rx: 16,
    fill: "#10243E",
    stroke: "#2B5A85"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 378,
    r: 7,
    fill: "#30D6A1"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 83,
    y: 370,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 83,
    dy: 0
  }, "OPERATIONAL ADOPTION"), /*#__PURE__*/React.createElement("tspan", {
    x: 83,
    dy: 19
  }, "The system is used, measured and improved in real work."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentImplementationAdoptionOperationalModelDesktop);
export default __webpack_public_path__ + "static/media/custom-development-implementation-adoption-operational-model-desktop.db097c4e089a215b07c0bd5facbece19.svg";
export { ForwardRef as ReactComponent };